import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { init } from '@sentry/angular-ivy';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.name === 'staging') {
    enableProdMode();
    // Sentry integration
    init({
        environment: environment.name,
        release: 'scope-frontend@' + environment.version,
        dsn: 'https://22dfed699dac333e3296668cccb5f580@o1021883.ingest.sentry.io/4506541291274240',
        ignoreErrors: [
            'BrowserAuthError',
            'ClientAuthError',
            'InteractionRequiredAuthError',
            'ServerError',
            'NG0901',
            'NG02100', // abandoned date pipe
            'JSON-RPC', // 403 api response
            'interaction_required',
            'server_error: AADB2C90273', // auth error
            'monitor_window_timeout',
            'Unknown Error',
            'user.read',
            'ethereum'
        ]
    });
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
